import locales from 'public/locales';

const DEFAULT_LOCALE = 'en';

const getSharedConfig = (locale = DEFAULT_LOCALE) => ({
  debug: false,
  fallbackLng: DEFAULT_LOCALE,
  lng: locale,
  resources: {
    [locale]: locales[locale],
    [DEFAULT_LOCALE]: locales[DEFAULT_LOCALE]
  },
  ns: ['translations', 'auth', 'employerHome', 'features', 'candidates'],
  defaultNS: 'translations',
  react: {
    wait: false,
    nsMode: 'fallback',
    useSuspense: false
  },
  keySeparator: '.',
  nsSeparator: ':',
  interpolation: {
    escapeValue: false, // not needed for react
    formatSeparator: ','
  }
});

export default getSharedConfig;
